<script>
import InfoOverlay from 'ne01-common/src/components/InfoOverlay';

export default {
  name: 'InfoButton',
  components: {
    InfoOverlay: InfoOverlay
  },
  props: {
    contentData: Object,
  },
  data: () => ({
    showOverlay: false,
  }),
  methods: {
    toggleOverlay() {
        this.showOverlay = !this.showOverlay;
        this.$emit('stateChanged', this.showOverlay ? 'open' : 'close');
    }
  }
}
</script>

<template>
  <div class="info-button" v-if="contentData">
    <button class="info-button__btn" v-on:click="toggleOverlay"></button>
    <info-overlay class="info-button__overlay" v-if="showOverlay" v-on:close="toggleOverlay" v-bind:contentData="contentData" />
  </div>
</template>

<style scoped lang="scss">
.info-button__btn {
  position: relative;
  --webkit-appearance: none;
  background-color: var(--light,red);
  background: var(--light);
  border: none;
  color: var(--dark,pink);
  font-size: 1.5rem;
  outline: none;
  cursor: pointer;
  line-height: 3rem;
  height: 3rem;
  width: 3rem;
  text-align: center;
  padding: 0;

  &::before {
    content: 'i';
    color: var(--dark, black);
    font-family: var(--font-family-primary);
    font-size: 2rem;
    font-weight: bold;
  }
}

.info-button__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--color-main);
  z-index: 99;
  padding: 0 var(--bezel);
  padding-top: var(--bezel);
  padding-bottom: var(--bezel);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-y: scroll;
}
</style>
